import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { RecommendedConnection } from '../../services-mock/mock-feed.service';

@Component({
  selector: 'app-recommended-connections',
  standalone: true,
  imports: [CommonModule, ButtonModule, AvatarModule],
  template: `
    <div class="connections-container">
      <div class="connections-header">
        <p-avatar
          label="PP"
          shape="circle"
          size="normal"
          styleClass="patty-avatar"
        ></p-avatar>
        <div class="connections-header-text">
          <h3>Recommended Connections</h3>
          <div class="connections-subtitle">From Pathway Patty</div>
        </div>
      </div>
      <div class="connections-list">
        <div *ngFor="let connection of connections" class="connection-item">
          <div class="connection-info">
            @if (connection.avatar) {
            <p-avatar
              [image]="connection.avatar"
              shape="circle"
              size="normal"
            ></p-avatar>
            } @else {
            <p-avatar
              [label]="connection.initials || 'U'"
              shape="circle"
              size="normal"
            ></p-avatar>
            }
            <div class="connection-details">
              <div class="connection-name-row">
                <span class="connection-name">{{ connection.name }}</span>
                <span *ngIf="connection.badge" class="connection-badge">
                  {{ connection.badge }}
                </span>
              </div>
              <div class="connection-title">
                {{ connection.title }} • {{ connection.company }}
              </div>
            </div>
          </div>
          <button
            pButton
            type="button"
            class="follow-button"
            label="Follow"
            icon="pi pi-wifi"
          ></button>
        </div>
      </div>
      <div class="connections-footer">
        <button
          pButton
          type="button"
          class="show-more-button"
          label="Show More"
          icon="pi pi-arrow-right"
          iconPos="right"
        ></button>
      </div>
    </div>
  `,
  styles: [
    `
      .connections-container {
        background-color: #ffffff;
        border-radius: 8px;
        padding: 1.5rem;
        margin-bottom: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }

      .connections-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #e5e5e5;
      }

      .connections-header-text {
        flex: 1;
      }

      .connections-header h3 {
        margin: 0 0 0.25rem 0;
        font-size: 1.1rem;
        font-weight: 600;
        color: #000000;
      }

      .connections-subtitle {
        font-size: 0.85rem;
        color: #666666;
      }

      .connections-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      .connection-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem 0;
      }

      .connection-info {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex: 1;
      }

      .connection-details {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .connection-name-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.25rem;
      }

      .connection-name {
        font-weight: 600;
        font-size: 0.95rem;
        color: #000000;
      }

      .connection-badge {
        background-color: #ff4444;
        color: #ffffff;
        padding: 0.15rem 0.5rem;
        border-radius: 12px;
        font-size: 0.75rem;
        font-weight: 600;
      }

      .connection-title {
        font-size: 0.85rem;
        color: #666666;
      }

      .follow-button {
        font-size: 0.9rem;
        padding: 0.5rem 1rem;
      }

      .connections-footer {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #e5e5e5;
        text-align: center;
      }

      .show-more-button {
        background: transparent;
        color: #0066cc;
        border: 1px solid #0066cc;
        font-size: 0.9rem;
        padding: 0.5rem 1.5rem;
      }

      .show-more-button:hover {
        background-color: #f0f7ff;
      }

      :host ::ng-deep {
        .p-button {
          border: none;
          box-shadow: none;
        }

        .p-button:focus {
          box-shadow: none;
        }

        .p-avatar {
          width: 40px;
          height: 40px;
        }

        .patty-avatar {
          background-color: #ff6b6b;
          color: #ffffff;
          font-weight: 600;
        }
      }
    `,
  ],
})
export class RecommendedConnectionsComponent {
  @Input() connections: RecommendedConnection[] = [];
}
